import {useRouter} from 'next/router'
import React from 'react'
import useHotjarExternal from 'react-use-hotjar'

const useHotJar = (id: number, version: number, enableDebug = false): void => {
  const router = useRouter()
  const {initHotjar, stateChange} = useHotjarExternal()

  React.useEffect(() => {
    initHotjar(id, version, enableDebug)

    router.events.on('routeChangeComplete', stateChange)

    return () => {
      router.events.off('routeChangeComplete', stateChange)
    }
  }, [id, version, router, initHotjar])
}

export default useHotJar
